export const createExportRequestParams = (payload, Entity) => {
  if (!payload) return null;

  const user = JSON.parse(localStorage.getItem("user"));

  const exportParams = {
    UserID: payload.UserID,
    EntityID: EntityToIDMapping[Entity] || null, // Map entity name to ID
    RequestedByEmailID: user?.Email || null,
  };

  // Add FromDateTime and ToDateTime if they exist
  if (payload.FromDateTime) {
    exportParams.FromDateTime = payload.FromDateTime;
  }
  if (payload.ToDateTime) {
    exportParams.ToDateTime = payload.ToDateTime;
  }

  // Add all keys from Filter object dynamically
  if (payload.Filter && typeof payload.Filter === "object") {
    Object.entries(payload.Filter).forEach(([key, value]) => {
      // Only add non-null and non-empty values
      if (value !== null && value !== undefined && value !== "") {
        exportParams[key] = value;
      }
    });
  }

  // Add filter array fields (convert to comma-separated strings if they have values)
  if (payload.filters && typeof payload.filters === "object") {
    Object.entries(payload.filters).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length > 0) {
        exportParams[key] = value.join(",");
      }
    });
  }

  console.log("Export request params: ", exportParams);

  return exportParams;
};


const EntityToIDMapping = {
  "Alert": 1,
  "DeviceStatus": 2,
  "Master": 3
}